import bilAPI from '../api';

export const getSchools = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/core/schools/', { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

// Every school matching `params`: walks the API's pages until there is no next one
export const getAllSchools = async (params) => {
  const schools = [];
  for (let page = 1; ; page += 1) {
    const res = await getSchools({ ...params, page, page_size: 100 });
    schools.push(...(res.results ?? []));
    if (!res.next) return schools;
  }
};

export const getDistricts = (params, signal) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/core/district/', { params, signal })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getRegions = (exam_year) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/core/regions/', { params: { exam_year } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
